module.exports = __webpack_public_path__ + "img/icon1.cb646d2e.png";